/* eslint-disable max-lines */
const ru = {
  nav: {
    home: "Главная",
    drops: "Дропы",
    upcomingDrops: "Каталог Collezione",
    cinema: "Кино",
    archive: "Хранилище закрыто",
    activeDrops: "Активные дропы",
    signIn: "Войти",
    apply: "Войти в хранилище",
    enterCollezione: "Войти в хранилище",
    contact: "Контакты",
    signOut: "Выйти",
    hiddenCollezione: "Скрытое хранилище",
    privacy: "Политика конфиденциальности",
  },
  hero: {
    overline: "Осн. 2026 — Скрытое хранилище",
    headline1: "Garage Drops.",
    headline2: "Для тех, кто покупает истории, а не товары.",
    subtitle:
      "Частный архив кинематографичных объектов, легендарных рестомодов и редких коллекционных автомобилей. Появляются без предупреждения. Исчезают без объяснений.",
    teaserLabel: "До дропа осталось",
    liveBadge: "Дроп идёт · Только для участников",
    nextDropPrefix: "Следующий дроп —",
    viewDrops: "Смотреть дропы",
    apply: "Войти в хранилище",
    scroll: "Прокрутка",
  },
  countdown: {
    days: "Дней",
    hours: "Часов",
    minutes: "Минут",
    seconds: "Секунд",
    live: "Дроп в эфире",
    closes: "Дроп закрывается через",
    imminent: "Скоро · Анонс на подходе",
  },
  manifesto: {
    overline: "Манифест",
    body:
      "Мы не аукционный дом. Мы не продаём тому, кто предложит больше. Мы выпускаем по одному редкому объекту, и он исчезает.",
    pillars: [
      { n: "01", t: "Кураторский", d: "Каждый дроп реставрируется, фотографируется и документируется внутри." },
      { n: "02", t: "Нумерованный", d: "Каждый объект имеет серийный сертификат. Без копий." },
      { n: "03", t: "Скрытый", d: "Подробности для членов появляются только после регистрации." },
    ],
  },
  teaser: {
    overline: "Скоро",
    headline: "Готовится нечто редкое.",
    body:
      "Следующий дроп заперт в хранилище. Подайте заявку на членство, чтобы получить анонс раньше всех.",
    apply: "Получить ранний доступ",
    signIn: "Войти",
  },
  cinema: {
    overline: "Кино · Garage Drops",
    headline: "Хранилище в движении.",
    body:
      "Кураторские видеофрагменты: за кулисами, реставрации, кинематографичные поездки. Подборка обновляется без предупреждения.",
    publicOverline: "Открытая подборка",
    publicTitle: "Видео, доступное всем.",
    exclusiveOverline: "Эксклюзивное кино",
    exclusiveTitle: "Только для тех, кто вошёл в хранилище.",
    exclusiveLockedHeadline: "Есть вторая подборка, закрытая.",
    exclusiveLockedBody: "Войдите в хранилище, чтобы открыть всё.",
    exit: "Закрыть",
  },
  contact: {
    overline: "Контакты · Garage Drops",
    headline: "Напишите нам. Отвечаем лично.",
    body: "Для частных запросов, сотрудничества, продажи и консигнации.",
    directOverline: "Прямой email",
    directHeadline: "Предпочитаете написать напрямую?",
    directBody: "Отвечаем в течение 24 часов.",
    firstName: "Имя",
    lastName: "Фамилия",
    email: "Email",
    country: "Страна",
    message: "Сообщение",
    messagePlaceholder: "Хотел бы получить информацию...",
    submit: "Отправить сообщение",
    submitting: "Шифрование…",
    successText: "СООБЩЕНИЕ ПРИНЯТО",
    successSub: "Мы ответим лично.",
    error: "Не удалось отправить. Попробуйте снова.",
  },
  releases: {
    overline: "Текущие релизы",
    headline: "Сейчас в хранилище.",
    allDrops: "Все дропы →",
  },
  membership: {
    overline: "Членство",
    headline: "Некоторые дропы видны только когда дверь открыта.",
    body:
      "Членство бесплатное. Укажите страну, выберите фразу-пароль и откройте архив — каждый дроп, каждую историю, каждое фото.",
    apply: "Войти в хранилище",
  },
  drops: {
    overline: "Хранилище",
    headline: "Текущие дропы.",
    subtitle:
      "Каждый релиз живёт здесь недолго. После таймера объект уходит в частную коллекцию или в архив.",
    empty: "Дропы пока не показаны. Хранилище между релизами.",
    loading: "Загрузка…",
    membersOnly: "Только для членов",
    live: "В эфире",
    unlockingOverline: "Статус хранилища",
    unlockingHeadline: "Следующий Garage Drop откроется скоро",
    unlockingMystery: "Некоторые двери открываются только в нужный час.",
    showcaseLabel: "Архив хранилища — без имён",
  },
  drop: {
    backLink: "К списку дропов",
    membersOnlyHeadline: "Этот дроп зарезервирован для внутреннего круга.",
    lockedOverline: "Скоро откроется",
    lockedHeadline: "Этот дроп вот-вот будет раскрыт.",
    lockedBody: "Детали появятся здесь, как только обратный отсчёт дойдёт до нуля. Оставайтесь рядом — хранилище откроется скоро.",
    backHome: "На главную",
    membersOnlyBody:
      "Подайте заявку на членство, чтобы открыть фото, характеристики, историю и таймер.",
    apply: "Подать заявку",
    signIn: "Войти",
    object: "Объект",
    specs: "Характеристики",
    gallery: "Галерея",
    story: "История",
    notFound: "Дроп не найден.",
    backToCollezione: "Вернуться в хранилище",
    teaserOverline: "Скоро дроп",
    teaserHeadline: "Пока — только намёк.",
    teaserBody: "Полный дроп будет раскрыт только в момент запуска. Оставайтесь в хранилище — мы сообщим первыми.",
    price: "Цена",
    priceOnRequest: "По запросу",
    interested: "Мне интересно",
    inCatalogOverline: "В каталоге",
    inCatalogHeadline: "В данный момент не продаётся.",
    inCatalogBody:
      "Только один экземпляр одновременно официально выходит через кинематографическую систему дропов. Этот автомобиль находится в частном архиве и может вернуться, когда подаст знак сигнал.",
    inCatalogMemberBody:
      "Этот автомобиль сейчас не продаётся, но входит в частную коллекцию. Заполните форму ниже, чтобы запросить подробную информацию.",
    inCatalogCta: "Стать членом",
    categories: {
      esterno: "Экстерьер",
      interno: "Интерьер",
      sx: "Левая сторона",
      dx: "Правая сторона",
      sopra: "Сверху",
      sotto: "Снизу",
      particolari: "Детали",
      restauro: "Реставрация · Фото и видео",
      video: "Видео",
    },
  },
  signalPrivileges: {
    overline: "Привилегии сигнала",
    headline: "Что вы открываете внутри хранилища.",
    body: "Сигнал — это частная линия. Немногие имена, ранний доступ, передачи, которые никогда не попадают в публичные каналы.",
    items: [
      "Ранний доступ к частным дропам",
      "Машины, никогда не публиковавшиеся",
      "Конфиденциальные пред-дроп передачи",
      "Персональные переговоры с Concierge",
      "Приоритет на будущие коллекционные дропы",
      "Полные кинематографические передачи в хранилище",
      "Доступ к частному архиву",
    ],
    footer: "Сигнал — закрытый. Только избранные.",
  },
  howItWorks: {
    overline: "Как это работает",
    headline: "Пять шагов. Один полный дроп.",
    steps: [
      "Дроп готовится приватно.",
      "Члены получают сигнал первыми.",
      "Машина появляется на ограниченное время.",
      "Переговоры идут через Concierge.",
      "Дроп уходит в архив и исчезает.",
    ],
  },
  archive: {
    overline: "Конфиденциально · Закрытый архив",
    headline: "Хранилище закрыто.",
    body: "Машины, прошедшие через хранилище и исчезнувшие. Истории завершены. Передачи прекращены.",
    empty: "Закрытых передач пока нет. Завершённые сигналы появятся здесь.",
    statusLabels: {
      ended: "Сигнал прекращён",
      closed: "Передача закрыта",
      locked: "Дроп заблокирован",
      lost: "Сигнал потерян",
      archived: "Архив",
    },
    whispers: [
      "Сигнал может вернуться.",
      "Статус доступности неизвестен.",
      "Передача прекращена.",
      "История закрыта.",
      "Подтверждений возврата нет.",
    ],
  },
  auth: {
    loginOverline: "Вход",
    loginHeadline: "Хранилище узнаёт вас.",
    loginBody: "Введите данные, чтобы открыть архив.",
    email: "Email",
    passwordLabel: "Фраза-пароль",
    submitLogin: "Войти",
    submittingLogin: "Проверка…",
    notMember: "Ещё не член?",
    applyLink: "Войти в хранилище",

    registerOverline: "Заявка",
    registerHeadline: "Войдите в архив.",
    registerBody:
      "Членство бесплатное и таким останется. Скажите, где вы находитесь.",
    country: "Страна",
    firstName: "Имя",
    lastName: "Фамилия",
    passwordMin: "Фраза-пароль (мин. 6)",
    privacyConsent1: "Я прочитал(а) и принимаю",
    privacyConsentLink: "Политику конфиденциальности",
    privacyConsent2:
      "и согласен(а) на обработку моих данных в соответствии с GDPR.",
    submitRegister: "Открыть хранилище",
    submittingRegister: "Открываем…",
    alreadyMember: "Уже внутри?",
    signInLink: "Войти",

    welcomeBack: "С возвращением в хранилище.",
    welcomeNew: "Добро пожаловать. Хранилище открыто.",
    privacyRequired: "Необходимо принять политику конфиденциальности.",
    cannotSignIn: "Не удалось войти.",
    cannotRegister: "Не удалось создать аккаунт.",
  },
  newsletter: {
    overline: "Рассылка",
    headline: "Дропы анонсируются прежде, чем появиться.",
    body:
      "Никакого спама и шума. Один кинематографичный анонс, когда выпускается что-то редкое.",
    yourEmail: "Ваш email",
    placeholder: "you@example.com",
    subscribe: "Подписаться",
    submitting: "...",
    success: "Вы в списке. Будьте у почты.",
    fail: "Подписка не удалась. Повторите.",
  },
  counter: {
    overline: "Внутренний круг",
    membersSuffix: "коллекционеров имеют ключи",
  },
  concierge: {
    label: "Консьерж",
    open: "Говорить с Консьержем",
    title: "Консьерж",
    subtitle: "Спросите что угодно о хранилище.",
    placeholder: "Напишите сообщение…",
    send: "Отправить",
    welcome: "Я Консьерж Garage Drops. Проведу вас по хранилищу — дропы, членство, архив. Спрашивайте.",
    typing: "Готовлю ответ…",
    error: "Линия ненадолго прервалась. Попробуйте снова.",
    close: "Закрыть",
  },
  intro: {
    line1: "Доступ к закрытой сети",
    line2: "Открытие хранилища",
    lineGlitch: "// СИГНАЛ // СИГНАЛ //",
    skip: "Пропустить",
    label: "Garage Drops · Закрытый доступ",
    check1: "Защищённое соединение",
    check2: "Идентификация посетителя",
    check3: "Разблокировка архива",
    granted: "ДОСТУП РАЗРЕШЁН",
    welcome: "Добро пожаловать в хранилище",
  },
  signal: {
    overline: "Закрытый сигнал",
    headline: "Одна передача — когда выпускается нечто редкое.",
    body: "Никакого маркетплейс-шума. Никакого спама. Дропы анонсируются здесь раньше, чем где-либо ещё.",
    placeholder: "ваш@личный.email",
    submit: "Подключиться к сигналу",
    submitting: "Передача…",
    successText: "ПЕРЕДАЧА ПРИНЯТА",
    successSub: "Будьте у почты.",
    error: "Не удалось подписаться. Попробуйте снова.",
    explainerLabel: "Что произойдёт при подписке",
    explainer1: "Только email — без аккаунта, без пароля.",
    explainer2: "Одна передача за 24 часа до каждого дропа.",
    explainer3: "Никакого спама. Отписка в один клик.",
  },
  offer: {
    overline: "Частный запрос",
    signedInOverline: "● Вы пишете как",
    useOtherEmail: "Другой email",
    useMyData: "Мой аккаунт",
    headline: "Заинтересованы? Оставьте след.",
    body: "Укажите ваши данные и что вы хотите узнать: цена, состояние, наличие. Мы свяжемся с вами лично и конфиденциально.",
    firstName: "Имя",
    lastName: "Фамилия",
    name: "Имя",
    email: "Email",
    country: "Страна",
    phone: "Телефон (опционально)",
    amount: "Сумма предложения",
    message: "Ваше сообщение",
    messagePlaceholder: "Хотел бы узнать цену · Заинтересован в частном просмотре · Прошу информацию о...",
    submit: "Мне интересно",
    submitting: "Шифрование…",
    privacyNote: "Зашифровано · Личный ответ в течение 24 ч",
    successText: "ЗАПРОС ПРИНЯТ",
    successSub: "Наш ответственный свяжется с вами в скором времени.",
    error: "Не удалось отправить. Попробуйте снова.",
  },
  presentation: {
    featuredOverline: "Текущий дроп",
    liveNow: "В эфире",
    countdownLabel: "До закрытия осталось",
    viewFullDrop: "Открыть дроп",
    apply: "Войти в хранилище",
    objectOverline: "Объект",
    galleryOverline: "Галерея",
    specsOverline: "Характеристики",
    storyOverline: "История",
    closingLine: "Когда таймер истечёт, объект исчезнет.",
    lockedHeadline: "Этот дроп запечатан.",
    lockedBody:
      "Подайте заявку на членство, чтобы открыть фото, характеристики и историю.",
    archiveLinkOverline: "Архив",
    archiveLinkBody: "Посмотрите дропы, уже ушедшие в частные коллекции →",
  },
  footer: {
    description:
      "Скрытое цифровое хранилище для редких автомобильных и кинематографичных коллекционных дропов.",
    navigateOverline: "Навигация",
    legalOverline: "Юридическое",
    legal: {
      privacy: "Политика конфиденциальности",
      cookies: "Политика cookies",
      terms: "Условия обслуживания",
    },
    nav: {
      home: "Главная",
      drops: "Текущие дропы",
      archive: "Архив",
      register: "Войти в хранилище",
      signIn: "Войти",
    },
    rights: "© {year} Garage Drops",
    tagline: "Хранилище открывается на закате",
    disclaimer:
      "Предмет из моей личной частной коллекции. Частная продажа. Продаётся как есть, без гарантии и без права возврата.",
  },
  privacy: {
    overline: "Юридическое",
    title: "Политика конфиденциальности",
    updated:
      "Последнее обновление: февраль 2026 · Соответствует GDPR ЕС (Рег. 2016/679) и итальянскому D.Lgs. 196/2003.",
    s1Title: "1. Контролёр данных",
    s1Body:
      "Garage Drops (\"Платформа\") является контролёром персональных данных, собранных через этот сайт. По любым вопросам пишите на",
    s2Title: "2. Какие данные мы собираем",
    s2Intro: "Мы обрабатываем следующие категории данных:",
    s2List: [
      "Данные аккаунта — email, хешированная фраза-пароль, страна.",
      "Подписка на рассылку — email, страна (необязательно), время.",
      "Технические данные — IP, user agent, базовые логи (хранятся до 90 дней).",
    ],
    s3Title: "3. Правовая основа и цель",
    s3Body:
      "Мы обрабатываем данные на основаниях: (a) договорная необходимость — для членства и доступа к дропам; (b) согласие — для рассылки, отзывается в любой момент; (c) законный интерес — для предотвращения мошенничества и целостности платформы.",
    s4Title: "4. Политика cookies",
    s4Body:
      "Garage Drops использует только строго необходимые cookies (httpOnly cookie аутентификации). Никаких сторонних трекинговых, рекламных или аналитических cookies.",
    s5Title: "5. Срок хранения",
    s5Body:
      "Данные аккаунта хранятся в течение членства и 24 месяца после запроса на удаление, для юридических записей. Данные рассылки — до отписки. Технические логи — 90 дней.",
    s6Title: "6. Обмен данными",
    s6Body:
      "Мы не продаём ваши данные. Мы передаём их только субподрядчикам, необходимым для работы платформы: облачный хостинг (в ЕС), доставка email (Resend, ЕС/США с SCC), объектное хранилище (инфраструктура Emergent).",
    s7Title: "7. Ваши права (Ст. 15-22 GDPR)",
    s7Intro: "Вы имеете право:",
    s7List: [
      "Получить доступ к данным и их копию.",
      "Запросить исправление неточных данных.",
      "Запросить удаление (право быть забытым).",
      "Ограничить или возразить против обработки.",
      "Перенос данных.",
      "Отозвать согласие в любой момент, без влияния на прошлую правомерность.",
      "Подать жалобу в итальянский орган защиты данных.",
    ],
    s7Outro: "Чтобы воспользоваться этими правами, напишите на",
    s8Title: "8. Безопасность",
    s8Body:
      "Фразы-пароли хранятся в виде bcrypt-хешей. Соединения по HTTPS. Токены аутентификации — в httpOnly Secure cookies. Доступ к админке защищён аутентификацией и скрытым маршрутом.",
    s9Title: "9. Условия обслуживания",
    s9Body:
      "Используя платформу, вы принимаете эти условия. Членство бесплатно и может быть отозвано по нашему усмотрению в случае злоупотреблений. Все дропы, фото и редакционный контент остаются собственностью Garage Drops или авторов-реставраторов и фотографов.",
    s10Title: "10. Изменения политики",
    s10Body:
      "Мы можем обновлять эту политику. О существенных изменениях члены будут уведомлены по email.",
  },
  upcoming: {
    overline: "Частная коллекция",
    headline: "Каталог Collezione.",
    subtitle:
      "Полная частная коллекция. Только один автомобиль одновременно официально продаётся; остальные остаются в каталоге. Члены могут запросить информацию о любой модели.",
    empty: "Каталог формируется. Следите за этой страницей.",
    locked: "Заблокировано",
    filterAll: "Всё",
    filterAuto: "Auto",
    filterMoto: "Moto",
  },
  quickInquiry: {
    overline: "Быстрый запрос",
    headline: "Есть вопрос? Напишите нам.",
    body: "Без регистрации. Короткое сообщение — мы ответим в личном порядке.",
    name: "Имя",
    email: "Email",
    message: "Ваше сообщение",
    send: "Отправить",
    sent: "Запрос отправлен. Ответим в ближайшее время.",
    error: "Не удалось отправить. Попробуйте ещё раз.",
    memberHook: "Хотите увидеть весь каталог?",
    memberCta: "Стать членом — полный доступ к Collezione",
  },
  welcome: {
    overline: "Добро пожаловать",
    headline: "Что такое Garage Drops.",
    body1:
      "Garage Drops — это частная коллекция редких автомобилей и редких мотоциклов, отреставрированных и тщательно отобранных из моей личной коллекции и из других частных коллекций, отобранных с особым вниманием.",
    body2:
      "Каждый автомобиль представлен через индивидуальный кинематографичный релиз. Только один экземпляр одновременно официально выставляется на продажу; остальные хранятся внутри Collezione.",
    body3:
      "Перед публикацией каждый автомобиль проходит проверки и дорожные испытания. Если полная задокументированная реставрация недоступна, автомобиль всё равно осматривается и тестируется нами и нашей авторизованной мастерской, чтобы гарантировать корректную работу и полную прозрачность для будущего владельца.",
    body4:
      "Частная продажа: каждый автомобиль поступает из моей личной коллекции или из тщательно отобранных частных коллекций, продаётся как есть, без гарантии и без права возврата.",
    languageLabel: "Язык",
    privacyPrefix: "Продолжая, вы подтверждаете, что ознакомились с",
    privacyLink: "Политика конфиденциальности",
    continue: "Войти в Collezione",
  },
  signalPrivileges: {
    overline: "Преимущества членов",
    headline: "Что открывает членство в Collezione.",
    body: "Станьте членом, чтобы получить доступ ко всему Каталогу Collezione и запрашивать частную информацию даже о моделях, не выставленных на продажу.",
    items: [
      "Полный доступ к каталогу",
      "История, фото и детали каждого автомобиля — даже не для продажи",
      "Личные запросы по любой модели",
    ],
    footer: "Одновременно официально продаётся только один экземпляр. Остальные — в каталоге.",
  },
};

export default ru;
